import { render, staticRenderFns } from "./AgentVirtualAccounts.vue?vue&type=template&id=c94d2984&scoped=true"
import script from "./AgentVirtualAccounts.vue?vue&type=script&lang=js"
export * from "./AgentVirtualAccounts.vue?vue&type=script&lang=js"
import style0 from "./AgentVirtualAccounts.vue?vue&type=style&index=0&id=c94d2984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94d2984",
  null
  
)

export default component.exports